import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { ScanShippingBoxPage } from "#/components/pages/scan-shipping-box/scan-shipping-box-page";

export const Route = createFileRoute("/$tenantCode/$market/scan-shipping-box")({
  beforeLoad: () => ({ getTitle: () => m["resources.scanShippingBox.name"]() }),
  component: ScanShippingBoxRoute,
});

function ScanShippingBoxRoute() {
  return <ScanShippingBoxPage />;
}
